import { createJsonQuery } from '@farfetched/core'
import { runtypeContract } from '@farfetched/runtypes'
import { Array } from 'runtypes'
import { IStock, Stock } from '@entities/stocks/contract'
import { allStocksUrl } from '@entities/stocks/api'
import { useStore, useStoreMap } from 'effector-react'

export const stocksQuery = createJsonQuery({
    request: {
        method: 'GET',
        url: () => allStocksUrl()
    },
    name: 'stockinit',
    initialData: [] as IStock[],
    serialize: 'ignore',
    response: {
        contract: runtypeContract(Array(Stock))
    }
})

export const $stocks = stocksQuery.$data

export const useStocks = () => useStore($stocks)
export const useStockById = (stockId: number) =>
    useStoreMap({
        store: $stocks,
        keys: [stockId],
        fn: (stocks, [id]) => stocks?.find((x) => x.id === id) || null
    })

stocksQuery.$error.watch((error) => {
    if (!error) return
    console.error(error)
})
